export const LIMIT_LOAD_DATA = 100;
